import { Injectable } from '@angular/core'
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router'
import { Observable } from 'rxjs/Observable'
import { AuthService } from '../../auth.service'
import { ProfileService } from '../services/profile.service'

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private profileService: ProfileService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    const token = AuthService.getToken(),
      profile = this.profileService.getStoredProfile()

    if (token.access_token !== undefined && profile.role === 'ROLE_ADMIN') {
      return true
    }

    localStorage.setItem('redirect', state.url)
    this.router.navigate(['/login'])
    return false
  }
}



// WEBPACK FOOTER //
// ./src/app/main/authentication/auth.guard.ts